import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back_arrow_circle_large",
  "use": "back_arrow_circle_large-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"back_arrow_circle_large\"><g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#6998E4\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M16 12.8 12.8 16l3.2 3.2m3.2-3.2h-6.4\" /><circle cx=\"16\" cy=\"16\" r=\"15\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol